// Redirects a retired page route to its replacement tab, keeping :leagueId.
// Used for bookmarks and stale mobile builds that still link to the old
// my-lineup/free-agents/stats/my-league/members/league-rules paths.
import { Navigate, useParams } from "react-router-dom";

function OldPathRedirect({ to }) {
  const { leagueId } = useParams();
  return <Navigate to={`/${leagueId}/${to}`} replace />;
}

export default OldPathRedirect;
